import type { BreakPoint } from '@lighthouse/core'
import { DeviceEnum, DevicePreviewEnum } from '@lighthouse/core'

export const DeviceTypeOption = [
    {
        label: 'PC端',
        value: DevicePreviewEnum.DESKTOP
    },
    {
        label: '移动端',
        value: DevicePreviewEnum.MOBILE
    }
]

export const BreakPointPreinstall: (Omit<BreakPoint, 'id'> & { id?: string; label: string })[] = [
    {
        icon: 'DeviceDesktop',
        name: '电脑',
        label: '电脑',
        width: 960,
        type: DevicePreviewEnum.DESKTOP,
        device: DeviceEnum.DESKTOP
    },
    {
        icon: 'DeviceTablet',
        name: '平板',
        label: '平板',
        width: 810,
        type: DevicePreviewEnum.MOBILE,
        device: DeviceEnum.TABLET
    },
    {
        icon: 'DeviceMobile',
        name: '手机',
        label: '手机',
        width: 390,
        type: DevicePreviewEnum.MOBILE,
        device: DeviceEnum.MOBILE
    },
    {
        icon: 'Regulation',
        name: '',
        label: '自定义',
        width: Number.NaN,
        type: DevicePreviewEnum.DESKTOP,
        device: DeviceEnum.CUSTOM
    }
]
